<div class="h-full gap-1">
  <ul class="flex h-full flex-row items-center">
    @for (item of breadcrumbItems(); track $index) {
      <li class="flex items-center">
        @if ($index > 0) {
          <i [class]="ICONS.caretRight + ' text-text-tertiary text-2xs mx-0.5'"></i>
        }
        <app-breadcrumb-item class="flex items-center" [item]="item" [isLast]="$last" />
      </li>
    }
  </ul>
</div>
